import getURLParameter from "./getURLParameter"

/**
 * @param {string} name
 * @return {string|null}
 */
function getFromUrl(name) {
  const v = getURLParameter(name)
  return v && v.length ? v : null
}

export { getFromUrl }
